'use strict';
import {DynamicPageService} from "../../services/dynamic-page/dynamic-page.service";
import mustache from "mustache";

const angular = require('angular');

export class templateIterComponent {
  constructor(SettingsService, DynamicPageService) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.SettingsService = SettingsService;
  }

  slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // remove special chars
      .replace(/[\s_-]+/g, '-') // replace spaces/underscores with -
      .replace(/^-+|-+$/g, ''); // remove leading/trailing -
  }

  $onInit() {

    this.tag =  (this.elementTag) ? this.elementTag : "div";

    let _METHOD = (this.public === 'true') ? "getPublicByName" : "getByName";

    this.SettingsService[_METHOD]({name: this.settings}, setting => {
      this.DynamicPageService[_METHOD]({name: this.template}, page => {
        const data = (this.key) ? setting.data[this.key] : setting.data;

        if (this.prefilterKey && this.prefilterValue) {
          this.data = data.filter(item => item[this.prefilterKey] && item[this.prefilterKey].toLowerCase().includes(this.prefilterValue.toLowerCase()));
        } else {
          this.data = data;
        }

        if (this.slugKey) {
          this.data = this.data.map(item => {
            item.slug = this.slugify(item[this.slugKey]);
            return item;
          })
        }

        this.filteredData = this.data;
        this.templateHtml = page.data
      }, err => {
        console.log("could not retrieve template");
      });

    }, err => {
      console.log('could not retrieve data for template');
    });
  }

  resetSearch() {
    this.searchTerm = "";
    this.filteredData = this.data;
  }

  doSearch() {
    if (!this.search || !this.searchKey)
      return;

    const trimmedSearchTerm = this.searchTerm.trim().toLowerCase();

    if (!trimmedSearchTerm) {
      this.filteredData = this.data;
      return;
    }

    // Support comma separated list of searchKeys "name,email,address"
    const searchKeys = this.searchKey
      .split(',')
      .map(key => key.trim())
      .filter(key => key);    // removes empty keys

    this.filteredData = this.data.filter(item =>
      searchKeys.some(key => {
        const value = item[key];

        return value != null &&
          value.toString().toLowerCase().includes(trimmedSearchTerm);
      })
    );
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduu.ap.components.template-iter', [])
  .component('templateIter', {
    template: require('./template-iter.component.html'),
    bindings: {
      settings: '@',
      key: '@',
      template: '@',
      elementTag: '@',
      cssClass: '@',
      public: '@',
      search: '@',
      searchKey: '@',
      searchLabel: '@',
      searchPlaceholder: '@',
      searchCssClass: '@',
      prefilterKey: '@',
      prefilterValue: '@',
      slugKey:'@'
    },
    controller: templateIterComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/template-iter/template-iter.component.js